var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "import-log-modal",
      attrs: {
        title: "",
        visible: _vm.show,
        "close-on-click-modal": false,
        width: "650px",
        bodyHeight: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("stores::products-info::import_log"))),
      ]),
      _c("z-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        ref: "table",
        attrs: {
          data: _vm.tableData,
          columns: _vm.columns,
          "max-height": 280,
          pagination: _vm.pagination,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
          "page-change": _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "status",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        row.status === 1
                          ? _vm.$t("stores::products-info::had_complete")
                          : _vm.$t("stores::products-info::ongoing")
                      ) +
                      " "
                  ),
                ]),
              ]
            },
          },
          {
            key: "operate",
            fn: function (ref) {
              var row = ref.row
              return [
                row.importFailNum
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.onClick(row.failDataUrl)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("stores::products-info::import_fail_log")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }